export interface EngineDisplayContentPayload {
    content?: string;
    presentationContent?: string;
}

export type EngineDisplayContentSource =
    | "presentation"
    | "content"
    | "fallback";

export interface ResolvedEngineDisplayContent {
    content: string;
    source: EngineDisplayContentSource;
    isPresentation: boolean;
}

export function resolveEngineDisplayContent(
    payload: EngineDisplayContentPayload,
    fallbackContent: string,
): ResolvedEngineDisplayContent {
    if (typeof payload.content === "string") {
        return {
            content: payload.content,
            source: "content",
            isPresentation: false,
        };
    }
    // Editor buffer must stay in persistence form (with external stubs)
    // to avoid writing hydrated inline outputs back to disk on save.
    // presentationContent is for display only and should not replace
    // editable content when no authoritative content override is provided.
    if (typeof fallbackContent === "string") {
        return {
            content: fallbackContent,
            source: "fallback",
            isPresentation: false,
        };
    }
    if (typeof payload.presentationContent === "string") {
        return {
            content: payload.presentationContent,
            source: "presentation",
            isPresentation: true,
        };
    }
    return {
        content: fallbackContent,
        source: "fallback",
        isPresentation: false,
    };
}
